<template>
    <td-dialog
        :lockScroll="false"
        :title="title"
        :before-close="labelDialogClose"
        :visible.sync="dialogLabelVisible"
        width="400px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form :model="labelInfo" label-position="right" label-width="95px" ref="labelInfo" :rules="rules">
            <el-form-item :label="$t('workFlowLabelGroup.LABEL_NAME')" prop="sName">
                <td-input v-model="labelInfo.sName" :minlength="1" :maxlength="20"></td-input>
            </el-form-item>
            <el-form-item :label="$t('workFlowLabelGroup.LABEL_REMARK')" prop="sRemark">
                <td-input v-model="labelInfo.sRemark" :minlength="1" :maxlength="20"> </td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('labelInfo')" :loading="submitLoading">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="labelDialogClose">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import groupApi from './../assets/api.js';
export default {
    props: ['title', 'dialogLabelVisible', 'editItem', 'isAdd', 'sLabelGroupId'],
    created() {
        // 为编辑状态则进行初始化数据
        if (!this.isAdd) {
            this.labelInfo = this.editItem;
            console.info();
        } else {
            this.labelInfo.sLabelGroupId = this.sLabelGroupId;
        }
    },
    // 定义变量
    data() {
        return {
            // 表单信息
            labelInfo: {
                sId: '',
                sName: '',
                sRemark: '',
                sLabelGroupId: '',
                iInitType: 0
            },
            submitLoading: false, // 保存按钮是否为加载状态
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('workFlowLabelGroupError.ERROR_PLEASE_INPUT_LABEL_NAME'), trigger: 'blur' },
                    { pattern: window.pangu.regex.CAPTION_RULE, message: this.$t('workFlowLabelGroupError.CAPTION_RULE_ERROR_MSG'), trigger: 'blur' }
                ],
                sRemark: [
                    { required: true, message: this.$t('workFlowLabelGroupError.ERROR_PLEASE_INPUT_LABEL_REMARK'), trigger: 'blur' },
                    { pattern: window.pangu.regex.CAPTION_RULE, message: this.$t('workFlowLabelGroupError.CAPTION_RULE_ERROR_MSG'), trigger: 'blur' }
                ]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    var param = {
                        sId: this.labelInfo.sId,
                        sName: this.labelInfo.sName,
                        sRemark: this.labelInfo.sRemark,
                        sLabelGroupId: this.labelInfo.sLabelGroupId,
                        iInitType: this.labelInfo.iInitType
                    };
                    if (this.isAdd) {
                        param.sId = this.getuuid();
                        groupApi.addLabel(JSON.stringify(param), response => {
                            this.submitLoading = false;
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('/workFlowLabel/addLabel', response.data.statusMessage);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('workFlowLabelGroup.ADD_SUCCESS'), type: 'success' });
                            this.$emit('labelSubmit');
                        });
                    } else {
                        groupApi.updateLabel(JSON.stringify(param), response => {
                            this.submitLoading = false;
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('/workFlowLabel/updateLabel', response.data.statusMessage);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('workFlowLabelGroup.MODIFY_SUCCESS'), type: 'success' });
                            this.$emit('labelSubmit');
                        });
                    }
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        labelDialogClose() {
            this.$emit('labelDialogClose');
        },
        //生成uuid
        getuuid() {
            return 'xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/[xy]/g, function(c) {
                let r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        }
    }
};
</script>
<style></style>
